import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { getVouchers } from './api/vouchers';
import VoucherCard from './components/VoucherCard';
import AllVouchersPage from './pages/AllVouchersPage';

function HomePage() {
  const [vouchers, setVouchers] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchVouchers = async () => {
    try {
      const data = await getVouchers();
      setVouchers(data);
      setError(null);
    } catch (err) {
      console.error(err);
      setError('Failed to load vouchers');
      setVouchers([]);
    }
  };

  const handleRedeem = async (code) => {
    try {
      const res = await fetch('https://dashboard.cohere.ph/api/redeem.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ code }),
      });

      const result = await res.json();

      if (result.error) {
        alert(result.error);
      } else {
        alert(result.message || 'Voucher redeemed!');
        setTimeout(fetchVouchers, 2000);
      }
    } catch (err) {
      console.error(err);
      alert('Redeem failed. Please try again.');
    }
  };

  useEffect(() => {
    fetch("https://dashboard.cohere.ph/api/session-info.php", {
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) {
          setError("You must log in from the dashboard first.");
          setVouchers([]);
        } else {
          fetchVouchers();
        }
      })
      .catch(err => {
        console.error("Session check failed:", err);
        setError("Failed to verify session.");
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="p-4">Checking session...</p>;
  if (error) return <p className="text-red-500 p-4">{error}</p>;
  if (!vouchers) return <p className="p-4">Loading vouchers...</p>;

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Your Vouchers</h1>
      <div className="grid gap-4">
        {vouchers.map((voucher) => (
          <VoucherCard key={voucher.code} voucher={voucher} onRedeem={handleRedeem} />
        ))}
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <nav className="p-4 bg-gray-100 flex gap-4">
        <Link to="/" className="font-semibold">My Vouchers</Link>
        <Link to="/all" className="font-semibold">All Vouchers</Link>
      </nav>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/all" element={<AllVouchersPage />} />
      </Routes>
    </Router>
  );
}

export default App;
